import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { closeVideoModalActive, toggleVideoActivity } from "../../../redux/slices/activityCategories";
import Input from "../../Input/input";
import Loader from "../../Loader";
import { validateLink } from "../ActivityCategories/utils";
import "./videoUpload.css";

export default function VideoUpload() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [youtubeActive, setYoutubeActive] = useState(false);
  const [uploadActive, setUploadActive] = useState(false);
  const [loading, setLoading] = useState(false);

  const [link, setLink] = useState("");
  const [error, setError] = useState("");

  const [videoThumbnailActive, setVideoThumbnailActive] = useState(false);
  const [youtubeThumbnailActive, setYoutubeThumbnailActive] = useState(false);

  const [thumbnailLink, setThumbnailLink] = useState("");
  const handleClose = () => dispatch(closeVideoModalActive());

  const handleSubmit = () => {
    navigate("/design");
  };

  const showYoutube = () => {
    setYoutubeActive(true);
    setUploadActive(false);
  };

  const showUpload = () => {
    setYoutubeActive(false);
    setUploadActive(true);
  };

  function get_youtube_thumbnail(url, quality) {
    if (url) {
      var video_id, thumbnail, result;
      if ((result = url.match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/))) {
        video_id = result.pop();
      } else if ((result = url.match(/youtu.be\/(.{11})/))) {
        video_id = result.pop();
      }

      if (video_id) {
        if (typeof quality == "undefined") {
          quality = "high";
        }

        var quality_key = "maxresdefault"; // Max quality
        if (quality == "low") {
          quality_key = "sddefault";
        } else if (quality == "medium") {
          quality_key = "mqdefault";
        } else if (quality == "high") {
          quality_key = "hqdefault";
        }

        var thumbnail = "http://img.youtube.com/vi/" + video_id + "/" + quality_key + ".jpg";
        return thumbnail;
      }
    }
    return false;
  }

  const showYoutubeThumbnail = (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const result = validateLink(link);
    if (result === null) {
      setError("Sorry! The requested url is not valid. Please try another.");
      return;
    }
    setYoutubeThumbnailActive(true);
    setYoutubeActive(false);
    setUploadActive(false);

    const thumbb = get_youtube_thumbnail(link, "high");
    setThumbnailLink(thumbb);
  };

  const showVideoUploadThumbnail = () => {
    setVideoThumbnailActive(true);
    setYoutubeActive(false);
    setUploadActive(false);
  };
  const uploadFileChange = (e) => {
    setVideoThumbnailActive(true);
    showVideoUploadThumbnail();
    let file = e.target.files[0];
    console.log(file);
    let blobURL = URL.createObjectURL(file);
    setTimeout(() => {
      document.getElementById("previewVideo").src = blobURL;
      document.getElementById("previewVideoTitle").innerText = file.name;
    }, 500);
  };

  // useEffect(() => {
  //   if(videoThumbnailActive){
  //     const container = document.getElementById('upload_video_container')
  //     container.addEventListener('drop', ()=>{

  //     })
  //   }
  //   return
  // }, [videoThumbnailActive])

  useEffect(() => {
    const timeoutID = window.setTimeout(() => {
      setLoading(false);
    }, 3000);
    return () => window.clearTimeout(timeoutID);
  }, [videoThumbnailActive, youtubeThumbnailActive]);

  const closeThumbnails = () => {
    setVideoThumbnailActive(false);
    setYoutubeThumbnailActive(false);
    setLoading(false);
  };

  console.log(videoThumbnailActive);

  return (
    <div className="modal_container modal-container-video-upload">
      <div className="video_upload_modal">
        <div className="video_upload_modal__wrapper">
          <div className="video_upload_modal__header_container">
            <div className="modal-header">Add a video</div>
            <p className="header-bottom">Simply add a YouTube link or upload your own video to make awesome activties.</p>
          </div>
          {youtubeThumbnailActive === false && videoThumbnailActive === false && (
            <div className="video_upload_modal__buttons">
              <button className="video_upload_modal__button video_upload_modal__button-youtube" id={youtubeActive ? "active" : ""} onClick={showYoutube}>
                <img src="/assets/icons/youtube.svg" />
                <div className="button_text"> Youtube Link </div>
              </button>

              <button className="video_upload_modal__button video_upload_modal__button-upload" id={uploadActive ? "active" : ""} onClick={showUpload}>
                <img src="/assets/icons/upload.svg" />
                <div className="button_text"> Upload </div>
              </button>
            </div>
          )}

          {youtubeActive ? (
            <form className="youtube_video_input_container" onSubmit={showYoutubeThumbnail}>
              <p className="enter_text">Enter link here :</p>
              <Input value={link} setValue={setLink} errorMsg={error} />
            </form>
          ) : uploadActive ? (
            <div className="upload_video_container">
              <div className="upload_video_container__wrapper">
                <p className="upload_video_container__header">Drag and Drop video file to upload</p>
                <p className="upload_video_container__header">or</p>
                <input id="choose_video" type="file" accept="video/*" style={{ display: "none" }} onChange={uploadFileChange} className="" />
                <label htmlFor="choose_video" className="btn-primary upload_video_container__button">
                  Browse
                </label>

                <p className="upload_video_container__footer">supported files -{`>`} mp4, mov, mpeg</p>
              </div>
            </div>
          ) : loading ? (
            <div className="center-xy loader_container">
              <Loader />
            </div>
          ) : youtubeThumbnailActive ? (
            <div className="video_thumbnail_container">
              <p className="video_thumbnail_container__title">YouTube Video Title ( Auto populated )</p>
              <img src={thumbnailLink} />{" "}
              <button className="btn-primary video_thumbnail_container__button" onClick={handleSubmit}>
                {" "}
                Start Creating Activity :){" "}
              </button>
            </div>
          ) : (
            videoThumbnailActive && (
              <div id="upload_video_container" className="video_thumbnail_container">
                {/* <Input errorMsg="" />
                <img src="assets/thumbnail.png" /> */}
                <p className="video_thumbnail_container__title" id="previewVideoTitle"></p>
                <video id="previewVideo" height="240" controls autoPlay>
                  Your browser does not support the video tag.
                </video>

                <button className="btn-primary video_thumbnail_container__button" onClick={handleSubmit}>
                  {" "}
                  Start Creating Activity :){" "}
                </button>
              </div>
            )
          )}
          {(videoThumbnailActive || youtubeThumbnailActive) && (
            <div className="arrow-back-icon icon-button" onClick={closeThumbnails}>
              <img src="/assets/icons/arrow-back.svg" />
            </div>
          )}
          <div className="close-icon icon-button" onClick={handleClose}>
            <img src="/assets/icons/close.svg" />
          </div>
        </div>
        <img src="/assets/clouds.png" className="clouds_bg" id={youtubeActive || uploadActive || videoThumbnailActive || youtubeThumbnailActive ? "up" : "down"} />
      </div>
      <div className="modal-overlay"></div>
    </div>
  );
}
